export const cmsBillingColumns = [
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "clientNumber",
        headerName: "User Contact No.",
        width: 160,
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
    {
        field: "package",
        headerName: "Package",
        width: 160,
    },
    {
        field: "activeFrom",
        headerName: "Active From",
        width: 160,
    },
    {
        field: "activeTo",
        headerName: "Active To",
        width: 160,
    },
    {
        field: "totalFee",
        headerName: "Total Fee",
        width: 160,
    },
    {
        field: "paidFee",
        headerName: "Paid Fee",
        width: 160,
    },
    {
        field: "feeDue",
        headerName: "Fee Due",
        width: 160,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        width: 160,
    },
];